// register component(s) with react habitat
import codeSplit from 'scripts/higher-order-components/codeSplit'
import l10n from './l10n'

export default {
  TopicItem: codeSplit({
    l10n,
    loadComponent: () =>
      import(
        /* webpackChunkName: "Button" */
        './index'
      ),
  }),
}
